import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { GoldAdvantages } from '@/domains/loyalty/modules/LoyaltyProgram/components/GoldAdvantages/GoldAdvantages';
import { useLoyaltyProgramActivated } from '@/domains/loyalty/modules/LoyaltyProgram/hooks/useLoyaltyProgramActivated.default';
import { LoyaltyProgramCard } from '@/domains/loyalty/modules/LoyaltyProgramHvc/components/LoyaltyProgramCard/LoyaltyProgramCard';
import { B2B_SUBSCRIPTIONS_MVP_FEATURE_FLAG } from '@/domains/loyalty/modules/Subscriptions/constants';
import { useUserHasSubscription } from '@/domains/loyalty/modules/Subscriptions/hooks/useUserHasSubscription';
import { RecruitmentTouchpoint } from '@/domains/loyalty/modules/Subscriptions/RecruitmentTouchpoint/RecruitmentTouchpoint';
import { ProAdvantages } from '@/domains/productDiscovery/ProductPage/common/components/Advantages/SuperProWithFallbacks/ProAdvantages';

export const SuperProWithFallbacks = () => {
  const [isSubscriptionsMvpEnabled] = useBooleanFlags([
    B2B_SUBSCRIPTIONS_MVP_FEATURE_FLAG,
  ]);

  const isUserSubscribed = useUserHasSubscription();

  const { isOptInLoyaltyProgramV2, isLoyaltyProgramV1Enabled } =
    useLoyaltyProgramActivated();

  if (isSubscriptionsMvpEnabled && !isUserSubscribed) {
    return <RecruitmentTouchpoint className="h-full" />;
  }

  if (
    isSubscriptionsMvpEnabled &&
    isUserSubscribed &&
    isLoyaltyProgramV1Enabled
  ) {
    return <GoldAdvantages />;
  }

  if (
    isSubscriptionsMvpEnabled &&
    isUserSubscribed &&
    isOptInLoyaltyProgramV2
  ) {
    return <LoyaltyProgramCard fullHeight />;
  }

  return <ProAdvantages />;
};
